import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";
import PagerSkeleton from "./PagerSkeleton";
import { RoundedLoader } from "./sharedSkeletonParts";

type ChipVariant = "tag" | "pill";

interface AlertsHistoryListSkeletonProps {
  items?: number;
  chipVariant?: ChipVariant;
}

const LINE_HEIGHT = 20;
const CHIP_HEIGHT = 27;
const CHIP_RADIUS = 3;
const PILL_HEIGHT = 23;

const TITLE_WIDTHS = [140, 130, 145, 135, 150, 138];
const SUBTITLE_WIDTHS = [190, 165, 205, 175, 195, 180];
const DETAIL_WIDTHS = [230, 260, 210, 245, 225, 255];
const CHIP_WIDTHS = [150, 120, 135, 150, 120, 135];
const PILL_WIDTHS = [66, 74, 93];

const LOADER_CLASS = "display-block skeleton-on-highlight-bg";

export const AlertsHistoryPaginationSkeleton = () => (
  <PagerSkeleton className="margin-top-15" loaderClassName={LOADER_CLASS} />
);

const ChipLoader = ({ variant, index }: Readonly<{ variant: ChipVariant; index: number }>) => {
  if (variant === "pill") {
    return (
      <RoundedLoader
        className={LOADER_CLASS}
        height={PILL_HEIGHT}
        width={PILL_WIDTHS[index % PILL_WIDTHS.length]}
        radius={PILL_HEIGHT / 2}
      />
    );
  }

  return (
    <ContentLoader
      className={LOADER_CLASS}
      height={CHIP_HEIGHT}
      width={CHIP_WIDTHS[index % CHIP_WIDTHS.length]}
      rx={CHIP_RADIUS}
      ry={CHIP_RADIUS}
    />
  );
};

export default function AlertsHistoryListSkeleton({
  items = 6,
  chipVariant = "tag",
}: Readonly<AlertsHistoryListSkeletonProps>) {
  return (
    <>
      {Array.from({ length: items }, (_, index) => (
        <div
          key={index}
          className={`display-flex align-items-start justify-content-between gap-15 padding-y-15 padding-right-20 ${
            index === items - 1 ? "" : "border border-style-solid border-bottom-only border-width-1 border-color-light"
          }`}
        >
          <div className="display-flex flex-column gap-5">
            <span className="text-size-14 text-medium">
              <ContentLoader
                className={LOADER_CLASS}
                height={LINE_HEIGHT}
                width={TITLE_WIDTHS[index % TITLE_WIDTHS.length]}
              />
            </span>
            <span className="text-color-gray text-size-14">
              <ContentLoader
                className={LOADER_CLASS}
                height={LINE_HEIGHT}
                width={SUBTITLE_WIDTHS[index % SUBTITLE_WIDTHS.length]}
              />
            </span>
            <span className="text-color-gray text-size-14">
              <ContentLoader
                className={LOADER_CLASS}
                height={LINE_HEIGHT}
                width={DETAIL_WIDTHS[index % DETAIL_WIDTHS.length]}
              />
            </span>
          </div>
          <span className="display-inline-block">
            <ChipLoader variant={chipVariant} index={index} />
          </span>
        </div>
      ))}
    </>
  );
}
